import "bootstrap/dist/css/bootstrap.min.css";
import "./Hero.css";

import React from "react";
import { assest } from "../../assest/assest";

// Import CSS


export default function Hero() {
  return (
    <section className="hero-section">
      {/* Background Image */}
      <div
        className="hero-background"
        style={{ backgroundImage: `url(${assest.L11})` }}
      ></div>

      {/* Content */}
      <div className="container hero-content">
        <img className="hero-image" src={assest.ex} alt="intro" />
        
        {/* Styled Paragraph */}
        <p className="lead">
          THE PREMIER UNIVERSITY BUSINESS MAGAZINE
        </p>

      
      </div>
    </section>
  );
}
